import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from "@asosteam/asos-web-component-library-button";
import styles from "./styles.css";
import { useLocaleProvider, useTranslate } from "../../context/locale-provider";
;
const Pagination = ({ count, handleNextPage, hasNextPage }) => {
    const translate = useTranslate(useLocaleProvider());
    return (_jsxs("div", { className: styles.container, children: [_jsx("p", { className: "app_leavesden2", children: translate("ugc_gallery_view_more_desc").replace("%{lookCount}", count) }), hasNextPage && (_jsx(Button, { buttonType: "secondary", onClick: () => handleNextPage(), fillContainer: false, children: translate("ugc_gallery_view_more_button") }))] }));
};
export default Pagination;
